export default function SlideOptionsSkeleton() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full animate-pulse">
      <div className="h-6 w-[40%] bg-gray-300 rounded mb-2" />
      <div className="h-5 w-[50%] bg-gray-200 rounded mb-6" />

      <div className="mt-6 flex flex-row justify-between gap-3 w-[100%] h-[12rem]">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center bg-white shadow-md rounded-lg px-8 w-[30%] h-[100%] border border-gray-200"
          >
            <div className="w-16 h-16 bg-gray-300 rounded-lg mb-3" />
            <div className="h-5 w-[100%] bg-gray-300 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}
